import React from "react";
import PropTypes from "prop-types";
import * as styles from "./SvgIcon.module.scss";

const SvgIcon = ({ svgCode, className = "" }) => {
  if (!svgCode) {
    console.error("SvgIcon requires a valid svgCode.");
    return null;
  }

  return (
    <div
      className={`${styles.icon} ${className}`}
      dangerouslySetInnerHTML={{ __html: svgCode }}
      aria-hidden="true"
    />
  );
};

SvgIcon.propTypes = {
  svgCode: PropTypes.string.isRequired, 
  className: PropTypes.string, 
};

export default SvgIcon;
